import { z } from "zod";

export const CbomLibrarySchema = z.object({
  library_id: z.number().int().optional(),
  library_name: z.string().nullable(),
  version: z.string().nullable(),
  path: z.string().nullable(),
  device_id: z.string().nullable(),
  os: z.string().nullable(),
  created_at: z.string().datetime().optional(),
});

export type CbomLibrary = z.infer<typeof CbomLibrarySchema>;
